import { Dialog, IconButton } from '@mui/material';
import { ICommonDialogHeaderProps, ICommonDialogProps } from '../../types/dialog';
import CloseIcon from '@mui/icons-material/Close';
import { JSX } from 'react';

export const CommonDialog = ({ isOpen, header, body, footer }: ICommonDialogProps) => {
  return (
    <>
      <Dialog
        open={isOpen}
        slotProps={{
          paper: {
            sx: {
              p: 3, // padding inside the dialog
              width: { xs: '90%', sm: 500 }, // responsive width
            },
          },
        }}
      >
        <div className="ss-ap-common-dialog-header">{header}</div>
        <div className="ss-ap-common-dialog-body">{body}</div>
        <div className="ss-ap-common-dialog-footer">{footer}</div>
      </Dialog>
    </>
  );
};

export const CommonDialogHeader = ({ title, onClose }: ICommonDialogHeaderProps): JSX.Element => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <div style={{ fontWeight: 600 }}>{title}</div>
    <IconButton size="small" onClick={onClose} sx={{ color: 'grey.700' }}>
      <CloseIcon />
    </IconButton>
  </div>
);
